import React from 'react'

import youtube from './../../../UI/general/social/youtube.svg'
import instagram from './../../../UI/general/social/instagram.svg'
import facebook from './../../../UI/general/social/facebook.svg'

interface Props{}

interface State{}

class SocialMedia extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
    }

    render(){
        return(
            <div className='social-media-container'>
                <div className='text-container'>
                    Siguenos
                </div>
                <div className='icon-container'>
                    <a className='social-container' href='https://www.youtube.com/c/AutecoMotocicletas' target="_blank">
                        <img src={youtube}/>
                    </a>
                    <a className='social-container' href='https://www.facebook.com/autecomotos/' target="_blank">
                        <img src={facebook}/>
                    </a>
                    <a className='social-container' href='https://www.instagram.com/autecomotos/' target="_blank">
                        <img src={instagram}/>
                    </a>
                </div>
            </div>
        )
    }
}

export default SocialMedia